export const verticalBarChartData = [
  { campaigns: '0', accounts: 2451, highlyLikely: 157 }, // second largest category
  { campaigns: '1', accounts: 3305, highlyLikely: 252 }, // largest category
  { campaigns: '2-3', accounts: 1712, highlyLikely: 155 }, // decreasing
  { campaigns: '3-5', accounts: 1217, highlyLikely: 94 }, // decreasing
  { campaigns: '>5', accounts: 560, highlyLikely: 43 }, // decreasing
];

export const accountsListData = [
  {
    name: 'Wayne Enterprises',
    domain: 'wayne.com',
    qualificationScore: 94,
    pipelinePredictScore: 87,
    uniqueVisitors: { current: 140, change: 10, weeklyTrend: [125, 130, 135, 138, 140] },
    pageVisits: { current: 450, change: 9, weeklyTrend: [420, 430, 440, 445, 450] },
    masEngagement: { current: 190, change: 15, weeklyTrend: [160, 170, 180, 185, 190] },
    competitorKeywordEngagement: {
      current: 120,
      change: 13,
      weeklyTrend: [110, 112, 115, 118, 120],
    },
  },
  {
    name: 'Stark Industries',
    domain: 'stark.com',
    qualificationScore: 93,
    pipelinePredictScore: 85,
    uniqueVisitors: { current: 150, change: 8, weeklyTrend: [140, 142, 145, 148, 150] },
    pageVisits: { current: 420, change: 7, weeklyTrend: [400, 405, 410, 415, 420] },
    masEngagement: { current: 180, change: 6, weeklyTrend: [170, 175, 178, 179, 180] },
    competitorKeywordEngagement: {
      current: 115,
      change: 9,
      weeklyTrend: [105, 107, 110, 113, 115],
    },
  },
  {
    name: 'Initech',
    domain: 'initech.com',
    qualificationScore: 92,
    pipelinePredictScore: 80,
    uniqueVisitors: { current: 150, change: 12, weeklyTrend: [140, 142, 145, 148, 150] },
    pageVisits: { current: 400, change: 8, weeklyTrend: [380, 390, 395, 398, 400] },
    masEngagement: { current: 160, change: 5, weeklyTrend: [150, 155, 158, 159, 160] },
    competitorKeywordEngagement: {
      current: 100,
      change: -2,
      weeklyTrend: [102, 101, 100, 100, 100],
    },
  },
  {
    name: 'Umbrella Corp',
    domain: 'umbrella.com',
    qualificationScore: 91,
    pipelinePredictScore: 83,
    uniqueVisitors: { current: 135, change: 7, weeklyTrend: [125, 128, 130, 133, 135] },
    pageVisits: { current: 410, change: 12, weeklyTrend: [380, 390, 400, 405, 410] },
    masEngagement: { current: 175, change: 9, weeklyTrend: [160, 165, 170, 172, 175] },
    competitorKeywordEngagement: {
      current: 110,
      change: 11,
      weeklyTrend: [100, 102, 105, 108, 110],
    },
  },
  {
    name: 'Globex Inc.',
    domain: 'globex.com',
    qualificationScore: 88,
    pipelinePredictScore: 72,
    uniqueVisitors: { current: 132, change: -5, weeklyTrend: [135, 134, 133, 132, 132] },
    pageVisits: { current: 270, change: -8, weeklyTrend: [290, 280, 275, 272, 270] },
    masEngagement: { current: 130, change: 10, weeklyTrend: [120, 122, 125, 128, 130] },
    competitorKeywordEngagement: { current: 95, change: 12, weeklyTrend: [85, 88, 90, 92, 95] },
  },
  {
    name: 'Wonka Industries',
    domain: 'wonka.com',
    qualificationScore: 86,
    pipelinePredictScore: 77,
    uniqueVisitors: { current: 145, change: -4, weeklyTrend: [135, 138, 140, 143, 145] },
    pageVisits: { current: 320, change: -5, weeklyTrend: [340, 330, 325, 322, 320] },
    masEngagement: { current: 140, change: 2, weeklyTrend: [135, 137, 138, 139, 140] },
    competitorKeywordEngagement: {
      current: 100,
      change: -2,
      weeklyTrend: [102, 101, 100, 100, 100],
    },
  },
  {
    name: 'Acme Corp',
    domain: 'acme.com',
    qualificationScore: 85,
    pipelinePredictScore: 75,
    uniqueVisitors: { current: 145, change: 10, weeklyTrend: [130, 135, 138, 140, 145] },
    pageVisits: { current: 300, change: 5, weeklyTrend: [280, 290, 295, 298, 300] },
    masEngagement: { current: 120, change: -3, weeklyTrend: [130, 125, 123, 122, 120] },
    competitorKeywordEngagement: { current: 90, change: 7, weeklyTrend: [80, 82, 85, 88, 90] },
  },
  {
    name: 'Cyberdyne Systems',
    domain: 'cyberdyne.com',
    qualificationScore: 84,
    pipelinePredictScore: 74,
    uniqueVisitors: { current: 150, change: 9, weeklyTrend: [135, 140, 145, 148, 150] },
    pageVisits: { current: 350, change: 10, weeklyTrend: [320, 330, 340, 345, 350] },
    masEngagement: { current: 150, change: 7, weeklyTrend: [140, 145, 148, 149, 150] },
    competitorKeywordEngagement: { current: 105, change: 8, weeklyTrend: [95, 98, 100, 103, 105] },
  },
  {
    name: 'Bluth Company',
    domain: 'bluth.com',
    qualificationScore: 81,
    pipelinePredictScore: 70,
    uniqueVisitors: { current: 120, change: -7, weeklyTrend: [130, 125, 123, 121, 120] },
    pageVisits: { current: 280, change: -6, weeklyTrend: [300, 290, 285, 282, 280] },
    masEngagement: { current: 125, change: -5, weeklyTrend: [130, 128, 127, 126, 125] },
    competitorKeywordEngagement: { current: 90, change: -4, weeklyTrend: [95, 93, 92, 91, 90] },
  },
  {
    name: 'Hooli',
    domain: 'hooli.com',
    qualificationScore: 80,
    pipelinePredictScore: 65,
    uniqueVisitors: { current: 98, change: 15, weeklyTrend: [80, 85, 90, 95, 98] },
    pageVisits: { current: 230, change: 3, weeklyTrend: [220, 225, 227, 229, 230] },
    masEngagement: { current: 105, change: -6, weeklyTrend: [110, 108, 107, 106, 105] },
    competitorKeywordEngagement: { current: 70, change: 4, weeklyTrend: [65, 66, 68, 69, 70] },
  },
  {
    name: 'Vandelay Industries',
    domain: 'vandelay.com',
    qualificationScore: 79,
    pipelinePredictScore: 68,
    uniqueVisitors: { current: 148, change: -8, weeklyTrend: [150, 149, 148, 148, 148] },
    pageVisits: { current: 320, change: -10, weeklyTrend: [350, 340, 330, 325, 320] },
    masEngagement: { current: 145, change: 2, weeklyTrend: [140, 142, 144, 144, 145] },
    competitorKeywordEngagement: { current: 85, change: -3, weeklyTrend: [90, 88, 86, 85, 85] },
  },
  {
    name: 'Soylent Corp',
    domain: 'soylent.com',
    qualificationScore: 76,
    pipelinePredictScore: 69,
    uniqueVisitors: { current: 141, change: 5, weeklyTrend: [130, 134, 137, 140, 141] },
    pageVisits: { current: 310, change: 7, weeklyTrend: [290, 300, 305, 308, 310] },
    masEngagement: { current: 135, change: -2, weeklyTrend: [140, 138, 137, 136, 135] },
    competitorKeywordEngagement: { current: 95, change: -1, weeklyTrend: [97, 96, 95, 95, 95] },
  },
  {
    name: 'Dunder Mifflin',
    domain: 'dundermifflin.com',
    qualificationScore: 78,
    pipelinePredictScore: 66,
    uniqueVisitors: { current: 110, change: 6, weeklyTrend: [100, 105, 107, 109, 110] },
    pageVisits: { current: 240, change: 3, weeklyTrend: [230, 235, 238, 239, 240] },
    masEngagement: { current: 110, change: -3, weeklyTrend: [115, 113, 112, 111, 110] },
    competitorKeywordEngagement: { current: 75, change: 2, weeklyTrend: [70, 72, 73, 74, 75] },
  },
];

export const mockedLeastEngagingAccounts = [
  {
    name: 'Acme Corp',
    domain: 'acme.com',
    qualificationScore: 83,
    pipelinePredictScore: 73,
    uniqueVisitors: { current: 480, change: 8, weeklyTrend: [440, 455, 465, 475, 480] },
    pageVisits: { current: 290, change: 4, weeklyTrend: [275, 285, 288, 289, 290] },
    impressions: { current: 115, change: -5, weeklyTrend: [125, 120, 118, 117, 115] },
    salesEngagementMins: { current: 88, change: 5, weeklyTrend: [78, 80, 83, 85, 88] },
  },
  {
    name: 'Globex Inc.',
    domain: 'globex.com',
    qualificationScore: 86,
    pipelinePredictScore: 70,
    uniqueVisitors: { current: 440, change: -6, weeklyTrend: [455, 450, 448, 445, 440] },
    pageVisits: { current: 260, change: -10, weeklyTrend: [280, 270, 265, 263, 260] },
    impressions: { current: 100, change: 10, weeklyTrend: [80, 85, 90, 95, 100] },
    salesEngagementMins: { current: 125, change: 8, weeklyTrend: [115, 117, 120, 123, 125] },
  },
  {
    name: 'Initech',
    domain: 'initech.com',
    qualificationScore: 90,
    pipelinePredictScore: 78,
    uniqueVisitors: { current: 580, change: 10, weeklyTrend: [540, 550, 560, 570, 580] },
    pageVisits: { current: 390, change: 6, weeklyTrend: [370, 380, 385, 388, 390] },
    impressions: { current: 105, change: -4, weeklyTrend: [110, 108, 107, 106, 105] },
    salesEngagementMins: { current: 155, change: 3, weeklyTrend: [145, 150, 152, 154, 155] },
  },
  {
    name: 'Hooli',
    domain: 'hooli.com',
    qualificationScore: 78,
    pipelinePredictScore: 63,
    uniqueVisitors: { current: 330, change: 13, weeklyTrend: [290, 310, 320, 325, 330] },
    pageVisits: { current: 225, change: 2, weeklyTrend: [215, 220, 222, 224, 225] },
    impressions: { current: 75, change: 2, weeklyTrend: [70, 71, 72, 74, 75] },
    salesEngagementMins: { current: 102, change: -8, weeklyTrend: [112, 110, 108, 105, 102] },
  },
  {
    name: 'Vandelay Industries',
    domain: 'vandelay.com',
    qualificationScore: 77,
    pipelinePredictScore: 66,
    uniqueVisitors: { current: 510, change: -10, weeklyTrend: [530, 525, 520, 515, 510] },
    pageVisits: { current: 310, change: -12, weeklyTrend: [340, 330, 320, 315, 310] },
    impressions: { current: 80, change: -5, weeklyTrend: [90, 87, 85, 83, 80] },
    salesEngagementMins: { current: 140, change: 0, weeklyTrend: [140, 140, 140, 140, 140] },
  },
  {
    name: 'Umbrella Corp',
    domain: 'umbrella.com',
    qualificationScore: 89,
    pipelinePredictScore: 81,
    uniqueVisitors: { current: 580, change: 5, weeklyTrend: [560, 570, 575, 578, 580] },
    pageVisits: { current: 400, change: 10, weeklyTrend: [370, 380, 390, 395, 400] },
    impressions: { current: 105, change: 9, weeklyTrend: [95, 97, 100, 103, 105] },
    salesEngagementMins: { current: 170, change: 7, weeklyTrend: [155, 160, 165, 168, 170] },
  },
  {
    name: 'Soylent Corp',
    domain: 'soylent.com',
    qualificationScore: 74,
    pipelinePredictScore: 67,
    uniqueVisitors: { current: 460, change: 3, weeklyTrend: [440, 445, 450, 455, 460] },
    pageVisits: { current: 300, change: 5, weeklyTrend: [280, 290, 295, 298, 300] },
    impressions: { current: 90, change: -3, weeklyTrend: [96, 94, 92, 91, 90] },
    salesEngagementMins: { current: 130, change: -4, weeklyTrend: [138, 135, 133, 132, 130] },
  },
  {
    name: 'Wayne Enterprises',
    domain: 'wayne.com',
    qualificationScore: 92,
    pipelinePredictScore: 85,
    uniqueVisitors: { current: 630, change: 8, weeklyTrend: [590, 610, 620, 625, 630] },
    pageVisits: { current: 440, change: 7, weeklyTrend: [410, 420, 430, 435, 440] },
    impressions: { current: 115, change: 11, weeklyTrend: [105, 107, 110, 113, 115] },
    salesEngagementMins: { current: 185, change: 13, weeklyTrend: [155, 165, 175, 180, 185] },
  },
  {
    name: 'Stark Industries',
    domain: 'stark.com',
    qualificationScore: 91,
    pipelinePredictScore: 83,
    uniqueVisitors: { current: 600, change: 6, weeklyTrend: [570, 580, 590, 595, 600] },
    pageVisits: { current: 410, change: 5, weeklyTrend: [390, 395, 400, 405, 410] },
    impressions: { current: 110, change: 7, weeklyTrend: [100, 102, 105, 108, 110] },
    salesEngagementMins: { current: 175, change: 4, weeklyTrend: [165, 170, 172, 174, 175] },
  },
  {
    name: 'Wonka Industries',
    domain: 'wonka.com',
    qualificationScore: 84,
    pipelinePredictScore: 75,
    uniqueVisitors: { current: 470, change: -6, weeklyTrend: [490, 480, 475, 473, 470] },
    pageVisits: { current: 310, change: -7, weeklyTrend: [330, 320, 315, 313, 310] },
    impressions: { current: 95, change: -4, weeklyTrend: [99, 97, 96, 95, 95] },
    salesEngagementMins: { current: 135, change: 0, weeklyTrend: [135, 135, 135, 135, 135] },
  },
];

export const topVisitedPages = [
  { page: 'example.com/home', visits: 15 },
  { page: 'demandbase.com', visits: 150 },
  { page: 'demandbase.com/advertising', visits: 110 },
  { page: 'accountidfree.demandbase.com/hc/en-us/sections', visits: 90 },
  { page: 'app.qualified.com', visits: 55 },
  { page: 'community.demandbase.com', visits: 12 },
  { page: 'example.com/community/demandbase/com', visits: 23 },
  { page: 'example.com/products', visits: 120 },
  { page: 'example.com/about-us', visits: 850 },
  { page: 'example.com', visits: 120 },
  { page: 'example.com/contacts', visits: 8 },
];

export const pageVisits = [6000, 8500, 9000, 7000];

export const salesPersonaEngagementData = [
  {
    date: '2024-10-05',
    numberOfImpressions: 150,
    top25: 180,
    average: 60,
    bottom10: 45,
  },
  {
    date: '2024-10-12',
    numberOfImpressions: 175,
    top25: 200,
    average: 90,
    bottom10: 60,
  },
  {
    date: '2024-10-19',
    numberOfImpressions: 160,
    top25: 240,
    average: 120,
    bottom10: 48,
  },
  {
    date: '2024-10-26',
    numberOfImpressions: 140,
    top25: 75,
    average: 50,
    bottom10: 10,
  },
  {
    date: '2024-11-2',
    numberOfImpressions: 165,
    top25: 88,
    average: 55,
    bottom10: 17,
  },
];

const bestPerformingCampaigns = [
  { campaignName: 'Spring Cleaning Sale', ctr: 1.05, mqa: 92, endDate: '2023-12-01' },
  { campaignName: 'Mothers Day Special', ctr: 1.25, mqa: 95, endDate: '2024-04-10' },
  { campaignName: 'Flash Sale - Electronics', ctr: 1.4, mqa: 97, endDate: '2024-04-03' },
  { campaignName: 'Summer Blowout Sale', ctr: 1.1, mqa: 91, endDate: '2024-08-30' },
  { campaignName: 'Fall Festival Promotion', ctr: 1.0, mqa: 89, endDate: '2023-10-04' },
  { campaignName: 'Pre-Holiday Deals', ctr: 1.3, mqa: 94, endDate: '2023-11-12' },
  { campaignName: 'Labor Day Discounts', ctr: 0.95, mqa: 88, endDate: '2024-05-14' },
  { campaignName: 'Halloween Spooktacular', ctr: 1.15, mqa: 93, endDate: '2024-08-02' },
  { campaignName: 'Exclusive VIP Sale', ctr: 1.5, mqa: 98, endDate: '2024-08-01' },
  { campaignName: 'Limited-Time Anniversary Offers', ctr: 1.2, mqa: 96, endDate: '2024-04-28' },
  { campaignName: 'Year-End Clearance', ctr: 1.05, mqa: 90, endDate: '2023-11-28' },
  { campaignName: 'Weekend-Only Special', ctr: 0.85, mqa: 87, endDate: '2024-03-20' },
];

const activeCampaigns = [
  {
    campaignName: 'Summer Sale Campaign',
    ctr: 0.75, // in percentage
    budgetLeft: '$2,500',
    budgetTotal: '$10,000',
    impressions: 100000,
    clicks: 750,
    mqa: 85,
  },
  {
    campaignName: 'Back to School Campaign',
    ctr: 0.65,
    budgetLeft: '$1,200',
    budgetTotal: '$5,000',
    impressions: 75000,
    clicks: 488,
    mqa: 78,
  },
  {
    campaignName: 'Winter Discount Promotion',
    ctr: 0.9,
    budgetLeft: '$5,000',
    budgetTotal: '$12,000',
    impressions: 120000,
    clicks: 1080,
    mqa: 92,
  },
  {
    campaignName: 'Holiday Gift Guide Campaign',
    ctr: 0.55,
    budgetLeft: '$3,000',
    budgetTotal: '$7,500',
    impressions: 65000,
    clicks: 358,
    mqa: 76,
  },
  {
    campaignName: 'Black Friday Deals',
    ctr: 1.1,
    budgetLeft: '$8,500',
    budgetTotal: '$15,000',
    impressions: 150000,
    clicks: 1650,
    mqa: 95,
  },
  {
    campaignName: 'Cyber Monday Offers',
    ctr: 0.8,
    budgetLeft: '$4,000',
    budgetTotal: '$10,000',
    impressions: 90000,
    clicks: 720,
    mqa: 89,
  },
  {
    campaignName: 'New Year Special',
    ctr: 0.45,
    budgetLeft: '$1,000',
    budgetTotal: '$6,000',
    impressions: 50000,
    clicks: 225,
    mqa: 65,
  },
  {
    campaignName: 'Spring Sale',
    ctr: 0.85,
    budgetLeft: '$3,500',
    budgetTotal: '$9,000',
    impressions: 80000,
    clicks: 680,
    mqa: 88,
  },
  {
    campaignName: 'Valentine’s Day Offers',
    ctr: 0.95,
    budgetLeft: '$2,800',
    budgetTotal: '$8,000',
    impressions: 70000,
    clicks: 665,
    mqa: 90,
  },
  {
    campaignName: 'Clearance Sale Campaign',
    ctr: 0.7,
    budgetLeft: '$1,500',
    budgetTotal: '$5,500',
    impressions: 60000,
    clicks: 420,
    mqa: 72,
  },
  {
    campaignName: 'Product Launch Campaign',
    ctr: 0.5,
    budgetLeft: '$2,200',
    budgetTotal: '$7,000',
    impressions: 55000,
    clicks: 275,
    mqa: 70,
  },
];

export const campaignsPerformanceTableData = {
  activeCampaigns,
  bestPerformingCampaigns,
};

export const campaignPerformanceTrendChartData = [
  {
    date: '2024-10-01',
    numberOfImpressions: 95,
    top10: 80,
    average: 45,
    bottom10: 15,
  },
  {
    date: '2024-09-30',
    numberOfImpressions: 140,
    top10: 90,
    average: 50,
    bottom10: 24,
  },
  {
    date: '2024-09-29',
    numberOfImpressions: 110,
    top10: 65,
    average: 48,
    bottom10: 36,
  },
  {
    date: '2024-09-28',
    numberOfImpressions: 80,
    top10: 70,
    average: 40,
    bottom10: 30,
  },
  {
    date: '2024-09-27',
    numberOfImpressions: 120,
    top10: 85,
    average: 53,
    bottom10: 30,
  },
];

export const mockedBuyingGroups: { value: number; label: string }[] = [
  { value: 1, label: 'Cloud Storage Solutions' },
  { value: 2, label: 'Enterprise Networking Equipment' },
  { value: 3, label: 'Cybersecurity Solutions' },
  { value: 4, label: 'Data Analytics Platforms' },
  { value: 5, label: 'Collaboration and Communication Tools' },
];

export const mockedAccountLists: { value: number; label: string }[] = [
  { value: 4, label: 'Highly Engaged Accounts with No Open Opportunity (top 10k)' },
  { value: 3, label: 'Q3 Tech Accounts List' },
  { value: 2, label: 'Q2 Tech Accounts List' },
  { value: 1, label: 'Q1 Tech Accounts List' },
];

// The Placeholder 'EngagementTrendChart' data is commented out since the 3rd view will not be used for now.

// const mockFormattedEngagementTrendData = [
//   {
//     name: 'Intent',
//     data: [715.29, 1769.3, 1240.14, 1374, 1928],
//   },
//   {
//     name: 'Trending Intent',
//     data: [437, 884.75, 1902, 3880.3, 3247.8],
//   },
//   {
//     name: 'Page Visits',
//     data: [886.75, 2480.5, 2404.25, 3289.25, 3020.25],
//   },
// ];
//
// const mockTrendDateCategories = [
//   '2024-08-14',
//   '2024-08-21',
//   '2024-08-28',
//   '2024-09-04',
//   '2024-09-11',
// ];

// export const trendData = {
//   categories: mockTrendDateCategories,
//   series: mockFormattedEngagementTrendData,
// };

// export const engagedPagesAndKeywordsData = {
//   pages: [
//     {
//       name: 'community.demandbase.com',
//       journeyStages: [
//         { stage: 'Qualified', engagementMinutes: 54 },
//         { stage: 'Aware', engagementMinutes: 25 },
//         { stage: 'Engaged', engagementMinutes: 33 },
//         { stage: 'Opp', engagementMinutes: 100 },
//       ],
//     },
//     {
//       name: 'demandbase.com/advertising',
//       journeyStages: [
//         { stage: 'Qualified', engagementMinutes: 30 },
//         { stage: 'Aware', engagementMinutes: 20 },
//         { stage: 'Engaged', engagementMinutes: 25 },
//         { stage: 'MQA', engagementMinutes: 15 },
//         { stage: 'Opp', engagementMinutes: 10 },
//         { stage: 'Customer', engagementMinutes: 10 },
//       ],
//     },
//     {
//       name: 'accountidfree.demandbase.com/hc/en-us/sections',
//       journeyStages: [
//         { stage: 'Qualified', engagementMinutes: 25 },
//         { stage: 'Aware', engagementMinutes: 15 },
//         { stage: 'Engaged', engagementMinutes: 20 },
//         { stage: 'MQA', engagementMinutes: 10 },
//         { stage: 'Opp', engagementMinutes: 10 },
//         { stage: 'Customer', engagementMinutes: 10 },
//       ],
//     },
//     {
//       name: 'app.qualified.com',
//       journeyStages: [
//         { stage: 'Qualified', engagementMinutes: 10 },
//         { stage: 'Aware', engagementMinutes: 15 },
//         { stage: 'Engaged', engagementMinutes: 10 },
//         { stage: 'MQA', engagementMinutes: 10 },
//       ],
//     },
//     {
//       name: 'example.com/community/demandbase/com',
//       journeyStages: [
//         { stage: 'Aware', engagementMinutes: 5 },
//         { stage: 'Qualified', engagementMinutes: 8 },
//         { stage: 'MQA', engagementMinutes: 5 },
//         { stage: 'Customer', engagementMinutes: 5 },
//       ],
//     },
//   ],
//   keywords: [
//     {
//       name: 'ads',
//       journeyStages: [
//         { stage: 'Qualified', engagementMinutes: 30 },
//         { stage: 'Aware', engagementMinutes: 122 },
//         { stage: 'Engaged', engagementMinutes: 35 },
//         { stage: 'MQA', engagementMinutes: 14 },
//         { stage: 'Opp', engagementMinutes: 100 },
//         { stage: 'Customer', engagementMinutes: 10 },
//       ],
//     },
//     {
//       name: 'advertising',
//       journeyStages: [
//         { stage: 'Aware', engagementMinutes: 150 },
//         { stage: 'Qualified', engagementMinutes: 23 },
//         { stage: 'Opp', engagementMinutes: 10 },
//         { stage: 'Engaged', engagementMinutes: 35 },
//         { stage: 'MQA', engagementMinutes: 1 },
//       ],
//     },
//     {
//       name: 'demandbase',
//       journeyStages: [
//         { stage: 'Engaged', engagementMinutes: 25 },
//         { stage: 'Qualified', engagementMinutes: 35 },
//         { stage: 'Aware', engagementMinutes: 30 },
//         { stage: 'Opp', engagementMinutes: 20 },
//       ],
//     },
//     {
//       name: 'marketing',
//       journeyStages: [
//         { stage: 'MQA', engagementMinutes: 25 },
//         { stage: 'Qualified', engagementMinutes: 20 },
//         { stage: 'Aware', engagementMinutes: 15 },
//         { stage: 'Engaged', engagementMinutes: 20 },
//       ],
//     },
//     {
//       name: 'advertising strategy',
//       journeyStages: [
//         { stage: 'Aware', engagementMinutes: 20 },
//         { stage: 'Engaged', engagementMinutes: 25 },
//         { stage: 'Qualified', engagementMinutes: 25 },
//       ],
//     },
//   ],
// };

//export const firstPartyContacts = [
//   { name: 'Contact 1', clicks: 30, impressions: 100 },
//   { name: 'Contact 2', clicks: 45, impressions: 120 },
//   { name: 'Contact 3', clicks: 20, impressions: 80 },
//   { name: 'Contact 4', clicks: 60, impressions: 150 },
//   { name: 'Contact 5', clicks: 35, impressions: 110 },
//   { name: 'Contact 6', clicks: 50, impressions: 130 },
//   { name: 'Contact 7', clicks: 25, impressions: 90 },
//   { name: 'Contact 8', clicks: 55, impressions: 140 },
//   { name: 'Contact 9', clicks: 40, impressions: 115 },
//   { name: 'Contact 10', clicks: 65, impressions: 160 },
//   { name: 'Contact 11', clicks: 48, impressions: 125 },
//   { name: 'Contact 12', clicks: 33, impressions: 105 },
// ];

//
// export const thirdPartyContacts = [
//   { name: '3rd Party Contact 1', clicks: 50, impressions: 20 },
//   { name: '3rd Party Contact 2', clicks: 14, impressions: 120 },
//   { name: '3rd Party Contact 3', clicks: 0, impressions: 1 },
//   { name: '3rd Party Contact 5', clicks: 6, impressions: 23 },
//   { name: '3rd Party Contact 6', clicks: 1200, impressions: 200 },
//   { name: '3rd Party Contact 7', clicks: 60, impressions: 220 },
// ];
//
// export const contactLists = {
//   firstPartyContacts,
//   thirdPartyContacts,
// };
